import {webRequest, webNoTokenRequest} from '../../api'

// 拍表房源列表
export function getMeterHouseList() {
    return webRequest({
        url:'/v1/oauth/management/takeUtilityMeter/house/list',
        method:'get',
    })
}


// WEBPACK FOOTER //
// ./src/apis/mb/company/meterRecord.js